module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/flame_bg_sp-2fecdc234fa1ea9404ca5dc08bcc9cac.svg";